import { Routes, Route } from "react-router-dom";
import React from "react";

//Autenticação
import PrivateRouteAdm from "./services/PrivateRouteAdm";
import PrivateRouteClient from "./services/PrivateRouteClient";
//import PrivateRouteSupport from "./services/PrivateRouteSupport";

//Templates
import TemplateUsers from "./components/TemplateUsers";
import TemplateAdm from "./components/TemplateAdm";
//import TemplateSupport from "./components/TemplateSupport";

//Páginas abertas
import Login from "./pages/Login";
import Register from "./pages/Register";
import NewPassword from "./pages/NewPassword";

//Páginas ADM
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Documents from "./pages/Documents";

//Páginas de Clientes
import Home from "./pages/Home";
import UserProfile from "./pages/UserProfile";

export default function MainRoutes() {
  return (
    <Routes>
      {/* Rotas Abertas */}
      <Route path="/" element={<Login />}>
        <Route path="register" element={<Register />} />
        <Route path="newPassword" element={<NewPassword />} />
      </Route>
      {/* Rotas de Clientes */}
      <Route
        path="/home"
        element={
          <PrivateRouteClient>
            <TemplateUsers>
              <Home />
            </TemplateUsers>
          </PrivateRouteClient>
        }
      />
      {/* Rotas de Adm */}
      <Route
        path="/dashboard"
        element={
          <PrivateRouteAdm>
            <TemplateAdm title="DashBoard">
              <Dashboard />
            </TemplateAdm>
          </PrivateRouteAdm>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRouteAdm>
            <TemplateAdm title="Usuários">
              <Users />
            </TemplateAdm>
          </PrivateRouteAdm>
        }
      />
      <Route
        path="users/:id"
        element={
          <PrivateRouteAdm>
            <TemplateAdm title="Usuários">
              <UserProfile/>
            </TemplateAdm>
          </PrivateRouteAdm>
        }
      />
      <Route
        path="/documents"
        element={
          <PrivateRouteAdm>
            <TemplateAdm title="Documentos">
              <Documents />
            </TemplateAdm>
          </PrivateRouteAdm>
        }
      />
    </Routes>
  );
}
